import { DATE_FORMAT } from "helpers/common";
import React from "react";
import { Link } from "react-router-dom";
import { Stack, Badge } from "react-bootstrap";
// import UnControll

// export const selectRow = (props) => ({
//   mode: "checkbox",
//   clickToSelect: true,
//   selectionHeaderRenderer: ({ indeterminate, mode, ...rest }) => (
//     <div className="custom-control custom-checkbox">
//       <input
//         type="checkbox"
//         className="custom-control-input"
//         ref={(input) => {
//           if (input) input.indeterminate = indeterminate
//         }}
//         {...rest}
//       />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   selectionRenderer: ({ mode, rowKey, ...rest }) => (
//     <div className="custom-control custom-checkbox" key={rowKey}>
//       <input type="checkbox" className="custom-control-input" {...rest} />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   ...props,
// })

const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
};

const Columns = ({ handleUserStatus, handleEditHandler, deleteHandler }) => [
  {
    dataField: "icon",
    text: "Icon",
    formatter: (_, row) => (
      <>
        <img
          src={row.icon}
          alt=""
          style={{ height: 40, width: 40 }}
          className="img-fluid object-fit-contain"
        />
      </>
    ),
  },

  {
    dataField: "name",
    text: "Name",
    formatter: (_, row) => <span className="text-capitalize">{row.name}</span>,
  },
  {
    dataField: "symbol",
    text: "Symbol",
    formatter: (_, row) => (
      <span className="text-capitalize">{row.symbol}</span>
    ),
  },
  {
    text: "Created At",
    dataField: "createdAt",
    formatter: (_, row) => row.createdAt && DATE_FORMAT(row.createdAt),
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return <span>&nbsp;&nbsp;▲▼</span>; // Default (no sort)
      else if (order === "asc")
        return <span>&nbsp;&nbsp;▲</span>; // Ascending
      else if (order === "desc") return <span>&nbsp;&nbsp;▼</span>; // Descending
      return null;
    },
  },
  {
    text: "Updated At",
    dataField: "updatedAt",
    formatter: (_, row) => row.updatedAt && DATE_FORMAT(row.updatedAt),
    sort: true,
    sortCaret: (order, column) => {
      if (!order)
        return <span>&nbsp;&nbsp;▲▼</span>; // Default (no sort)
      else if (order === "asc")
        return <span>&nbsp;&nbsp;▲</span>; // Ascending
      else if (order === "desc") return <span>&nbsp;&nbsp;▼</span>; // Descending
      return null;
    },
  },
];
export default Columns;
